@if(error) {
  <div class="alert alert-danger">
    <strong>Error:</strong> {{ error }}
  </div>
}

<div>
  <div class="span9">
    <h1 data-automation-name="groupIndex">Groups</h1>
  </div>
  <p class="lead">
    Groups are a potential component of an OADR dispatch event that indicates the Division(s) of the event.
  </p>
</div>

@if(isAdmin) {
  <div class="span3" style="text-align:right; margin-bottom: 10px;">
    <a id="createGroup" class="btn btn-large btn-primary" (click)="nextPage($event, '/createGroup', router)"
       style="margin-top:9px;"> Create Group</a>
  </div>
}

@if(isLoading) {
  <app-loader
    message="Loading Groups...">
  </app-loader>
} @else {
  <table class="table table-striped">
    <thead>
    <!-- Column headers -->
    <tr>
      <th>ID</th>
      <th>Group ID</th>
      <th>Portfolio UUID</th>
      <th>Label</th>
      <th>Last Modified By</th>
      @if(isAdmin) {
        <th>Actions</th>
      }
    </tr>

    <!-- Search filter row -->
    <tr>
      <th><input placeholder="ID" class="input-sm form-control" type="search" [(ngModel)]="idSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Group ID" class="input-sm form-control" type="search" [(ngModel)]="groupIdSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Portfolio UUID" class="input-sm form-control" type="search" [(ngModel)]="portfolioUuidSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Label" class="input-sm form-control" type="search" [(ngModel)]="labelSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Modified By" class="input-sm form-control" type="search" [(ngModel)]="updatedBySearch" (input)="triggerSearch()"/></th>
      @if(isAdmin) {
        <th></th>
      }
    </tr>
    </thead>
    <tbody>
      @for(group of displayedGroups | paginate: paginationModel; track trackByGroupId($index, group)) {
        <tr>
          <td>{{group.id}}</td>
          <td>{{group.group_id}}</td>
          <td>{{group.division}}</td>
          <td>{{group.label}}</td>
          <td id="updated_by">{{group.updated_by}}</td>
          @if(isAdmin) {
            <td>
              <div class="btn-group">
                <a id="edit" class="btn btn-default btn-sm" (click)="nextPage(group.id, '/editGroup', router)"
                   name="editGroup">Edit</a>
                <button id="delete" class="btn btn-danger btn-sm" type="button" (click)="delete(group)">Delete</button>
              </div>
            </td>
          }
        </tr>
      }

      @if(displayedGroups.length <= 0) {
        <tr>
          <td [attr.colspan]="isAdmin ? 6 : 5" style="text-align: center;">No groups found matching your search criteria.</td>
        </tr>
      }
    </tbody>

    <tfoot>
    <tr>
      <td class="text-center" [attr.colspan]="isAdmin ? 6 : 5">
        <pagination-controls [id]="paginationId" (pageChange)="handlePageChange($event)" class="my-pagination"></pagination-controls>
      </td>
    </tr>
    </tfoot>
  </table>
}
